import axios from 'axios';
import { toast } from "../utils/customToast";
import { db } from '../libs/db'
/**
 * Create an Axios Client with defaults
 */

const options = {
    baseURL: import.meta.env.VITE_APIURL
};

const client = axios.create(options);


// Add a request interceptor
client.interceptors.request.use(function (config) {
    // Do something before request is sent
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    console.log(error);
    if (error.response.status === 401) {
        let user = JSON.parse(localStorage.getItem('user'));
        axios.post(`${options.baseURL}/Account/logout/${user.Email}`).then(r => console.log('logout successfull'));
        //place your reentry code
        removeItem('user');
        removeItem('token');
        toast.warning("Session expired. Please re-login to continue");
        window.location.href = '/';
        db.activity.clear();
    }
    return Promise.reject(error);
});

client.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        //place your reentry code
        removeItem('user');
        removeItem('token');
        toast.warning("Session expired. Please re-login to continue");
        window.location.href = '/login';
    } else {
        return Promise.reject(error);
    }
});


export default client;
